import { type StaticEnvironmentModel } from '@big-direkt/utils/environment';
import { jsonLd } from './json-ld';
import { metaTags } from './metatags';

export const environment: StaticEnvironmentModel = {
    appName: 'big-direkt-de',
    coBrowsingUrl: 'https://cdn.chatvisor.com/cdn/js/2xVJyahoh2.js',
    faqApiPath: 'jsonapi/node/faq_wrapper',
    formApiPath: 'api/form',
    jsonapiPath: '/jsonapi',
    jsonLd,
    metaTags,
    privateContentPath: '/de/meinebig',
    placeholdersApiPath: 'jsonapi/taxonomy_term/placeholders',
    production: true,
    publicFormsHostUrl: '/public-forms',
    restapiPath: '/api',
    sessionTokenApiPath: 'session/token',
    errorNodeIds: {
        notFound: {
            de: '38a41731-b53b-4885-b69c-9c9becd4a16d',
        },
    },
    servicePhoneNumber: {
        number: '+4923155570',
        title: '0231 5557-0',
    },
    errorPhoneNumber: {
        number: '+492315557320133',
        title: '0231 5557 320133',
    },
    user: {
        errorRedirect: '/de/technische-stoerung',
        logoutRedirect: '/',
    },
};
